import { useCallback, useRef } from 'react'
import { useRouteMatch } from 'react-router'

import Modal, { MCWithParams, useOpenModal } from 'components/uiKit/Modal'
import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { t } from 'services/Translation'
import { FileTypeEnum } from 'utils/fileTypes'

import FinderFilePicker, { FinderTabsEnum, IFinderFilePickerProps } from '../FinderFilePicker'
import FileUsagesCheckboxList from './FileUsagesCheckboxList'
import * as s from './FinderReplaceModal.module.scss'

type FinderReplaceModalReturnType = {
  targetFileMetaId: string
  fileUsageIds: string[]
}

type FinderReplaceModalParams = Omit<IFinderFilePickerProps, 'onFilePick'> & {
  sourceFileMetaId: string
}

export const FinderReplaceModal: MCWithParams<
  FinderReplaceModalParams,
  FinderReplaceModalReturnType
> = ({ params, onClose }) => {
  const { sourceFileMetaId, ...otherParams } = params
  const fileUsageIdsRef = useRef<string[]>([])

  const handleFilePick = useCallback(
    (fileId: string) => {
      if (fileUsageIdsRef.current.length == 0) {
        notify({
          type: NotificationType.error,
          message: t('modal.replaceFile.usageNotSelectedError'),
        })
        return
      }
      onClose({
        targetFileMetaId: fileId,
        fileUsageIds: fileUsageIdsRef.current,
      })
    },
    [onClose],
  )
  const handleUsageChange = useCallback((usageIds: string[]) => {
    fileUsageIdsRef.current = usageIds
  }, [])

  return (
    <Modal minHeight='100%' name='finderReplace' styleType='fullScreen'>
      <div className={s.container}>
        <FileUsagesCheckboxList
          companyId={params.params.companyId}
          onChange={handleUsageChange}
          sourceFileMetaId={sourceFileMetaId}
        />
        <FinderFilePicker {...otherParams} checkbox={false} onFilePick={handleFilePick} />
      </div>
    </Modal>
  )
}

interface IFilePickerReplaceParams {
  defaultContentType?: FileTypeEnum
  tabs?: FinderTabsEnum[]
  sourceFileMetaId: string
}

export const useFileReplaceModal = ({
  defaultContentType,
  tabs,
  sourceFileMetaId,
}: IFilePickerReplaceParams) => {
  const routeMatch = useRouteMatch<{
    projectId?: string
    companyId: string
    // fileMetaGroupId?: string
  }>()
  const { projectId, companyId } = routeMatch.params

  return useOpenModal(FinderReplaceModal, {
    params: {
      projectId,
      companyId,
    },
    defaultContentType,
    tabs,
    sourceFileMetaId,
  })
}

export default FinderReplaceModal
